<div class="professions-list">
  <div class="professions-list__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'professions.list.hero_title' | translate }}</h1>
    </div>
  </div>

  <div class="vacancy-container professions-list__content">
    <div class="vacancy-filters" style="grid-template-columns: repeat(2, 1fr);">
      <div>
        <label class="vacancy-filters__label">{{ 'shared.field_of_study' | translate }}</label>
        <lib-single-select-search
          class="vacancy-filters__select"
          [options]="vakgebiedOptions"
          [control]="vakgebiedControl"
          [placeholder]="'shared.all_fields' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onVakgebiedSelected($event)"
        ></lib-single-select-search>
      </div>
      <div>
        <label class="vacancy-filters__label">{{ 'shared.education_level' | translate }}</label>
        <lib-single-select-search
          class="vacancy-filters__select"
          [options]="opleidingsniveauOptions"
          [control]="opleidingsniveauControl"
          [placeholder]="'shared.all_levels' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onOpleidingsniveauSelected($event)"
        ></lib-single-select-search>
      </div>
    </div>

    <div class="vacancy-grid">
      <bwc-profession-card
        *ngFor="let profession of visibleProfessions"
        [profession]="profession"
        [isLiked]="isLiked(profession.id)"
        (liked)="toggleLike($event)"
      ></bwc-profession-card>
    </div>

    <div class="vacancy-load-more" *ngIf="hasMore">
      <button (click)="loadMore()">{{ 'shared.load_more' | translate }}</button>
    </div>
  </div>
</div>
